// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3tfFx","errorLogs":"styles_errorLogs__2ySp3"};